import { useUserProfile } from '@/providers/Auth';

import isGladeAdmin from './isGladeAdmin';
import isProduction from './isProduction';

const useIsGladeAdmin = (): boolean => {
  const profile = useUserProfile();
  // Allow non-production environments for testing (matching previous feature flag behavior)
  return !isProduction() || isGladeAdmin(profile);
};

export default useIsGladeAdmin;
